import { applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import epicMiddleware, { runEpics } from "./middlewares/epicMiddleware";
import devToolsOptions from "./devToolsOptions";

const middleware = [
  epicMiddleware,
];

export function runMiddleware() {
  runEpics();
}

export default composeWithDevTools(devToolsOptions)(applyMiddleware(...middleware));
